import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonDatetime, IonDatetimeButton, IonHeader, IonIcon, IonItem, IonLabel, IonModal, IonRow, IonText, IonToolbar, isPlatform } from '@ionic/react';
import dayjs from 'dayjs';
import { addCircle, arrowBack, calendar, removeCircle } from 'ionicons/icons';
import React, {useRef, useState, useEffect} from 'react'
import { SafetyPadding } from '../../components/SafetyPadding';
import CreateCalendarPickerTimeline from './CreateCalendarPickerTimeline';
import Api from "../../services/Api"

interface ErrorInterface  {
  status: boolean,
  message: string
  title: boolean,
  map: boolean,
  start: boolean,
  type: boolean
}

interface ComponentProps {
  error?: ErrorInterface
  length_minutes: number,
  start: string,
  handleLength: Function
  handleStart: Function
  setError: React.Dispatch<React.SetStateAction<ErrorInterface>>
  slideNext: Function
  slidePrevious: Function
  cancelCreate: Function
}
const CreateTime = ({ start, handleStart, handleLength, slideNext, cancelCreate } : ComponentProps) => {
  const api = Api.getInstance()
  const [date, setDate] = useState<string | string[] | null | undefined>()
  const [minutes, setMinutes] = useState(60)
  const [openSync, setOpenSync] = useState(false)
  const [endtime, setEndtime] = useState(dayjs(date as string).add(minutes, 'minutes').format('HH:mm'))
  const [openCal, setOpenCal] = useState(false)
  const now = dayjs().add(15, 'minutes').format('YYYY-MM-DDTHH:mmZ')

  useEffect(() => {
    if(start) {
      setDate(dayjs(start).format('YYYY-MM-DDTHH:mmZ'))
    } else {
      const minutesNow = dayjs(now).format('mm')
      const roundedMinutes = Math.ceil(parseInt(minutesNow) / 10) * 10
      const roundedTime = dayjs(now).set('minutes', roundedMinutes).format('YYYY-MM-DDTHH:mmZ')
      setDate(roundedTime)
    }
  }, [start])

  useEffect(() => {
    handleStart(dayjs(date as string).format('YYYY-MM-DD HH:mm'))
    setEndtime(dayjs(date as string).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm'))
  }, [date])

  useEffect(() => {
    handleLength(minutes)
    setEndtime(dayjs(date as string).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm'))
  }, [minutes])

  const convertHour = (minutes: number) => {
    const num = minutes
    const hours = (num / 60)
    const rhours = Math.floor(hours)

    return rhours
  }

  const convertMinutes = (minutes: number) => {
    const num = minutes
    const hours = (num / 60)
    const rhours = Math.floor(hours)
    const minute = (hours - rhours) * 60
    const rminutes = Math.round(minute)

    return rminutes
  }

  const closeCalendarSync = () => {
    setOpenSync(false)
  }

  const setTimePicker = (hour: number) => {
    handleStart(dayjs(date as string).set('hour', hour).set('minutes', 0).format('YYYY-MM-DD HH:mm'))
    setDate(dayjs(date as string).set('hour', hour).set('minutes', 0).format('YYYY-MM-DD HH:mm'))
    setEndtime(dayjs(date as string).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm'))
  }

  const errorLength = (newMinute: number) => {
    if(newMinute < 0) {
      return 0
    } else {
      return newMinute
    }
  }

  return (
    <IonContent className="p-8">
      <IonRow className="flex items-center justify-between mt-6">
        <IonCol className="flex items-center">
          <IonChip color="darkblue" className="circle_small flex justify-center items-center mx-2">1</IonChip>
          <h2 className="color_blue">{api.tr('starting_of_walk')}</h2>
        </IonCol>
        {isPlatform('capacitor') ? 
        <IonButton 
          fill="outline"
          onClick={() => {
            setOpenCal(true)
          }}>{api.tr('calendar')} <IonIcon icon={calendar}/></IonButton>: null }
      </IonRow>
      <IonRow className="p-8 createTime_responsive">
        <IonRow className="fullWidth responsive-row">
          <IonCard className="p-2 m-2 fullWidth">
            <IonCardHeader>
              <IonCardSubtitle mode="md" >{api.tr('date_of_walk')}</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <IonDatetimeButton
                className="font_header"
                id="trigger-button-1" 
                datetime="date"/>
            </IonCardContent>
          </IonCard>
        </IonRow>
        <IonRow className="fullWidth responsive-row">
          <IonCard className="p-2 m-2 fullWidth">
            <IonCardHeader>
              <IonCardSubtitle mode="md" >{api.tr('StartingTime_of_walk')}</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <IonDatetimeButton
                className="font_header"
                id="trigger-button-1" 
                datetime="datetime"/>
            </IonCardContent>
          </IonCard>
        </IonRow>
      </IonRow>
      <IonRow className="flex items-center mt-8">
        <IonChip color="darkblue" className="circle_small flex justify-center items-center mx-2">2</IonChip>
        <h2 className="color_blue">{api.tr('length_of_walk')}</h2>
      </IonRow>
      <IonRow className="p-8 createTime_responsive">
        <IonRow className="fullWidth responsive-row">
          <IonCard className="p-2 m-2 fullWidth">
            <IonCardHeader>
              <IonCardSubtitle mode="md" >Hour</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <IonRow>
                <IonCol className="flex justify-center items-center">
                  <IonButton 
                    fill="clear"
                    onClick={() => {
                      const newMinute = minutes - 60
                      setMinutes(errorLength(newMinute))
                    }}>
                    <IonIcon icon={removeCircle} size="large"/>
                  </IonButton>
                </IonCol>
                <IonCol className="flex justify-center items-center">
                  <div style={{'backgroundColor': '#edeef0'}} className="p-2 rounded-8 fullWidth">
                    <h1 className="color_black flex justify-center items-center">{convertHour(minutes)}</h1>
                  </div>
                </IonCol>
                <IonCol className="flex justify-center items-center">
                  <IonButton 
                    fill="clear"
                    onClick={() => {
                      const newMinute = minutes + 60
                      setMinutes(errorLength(newMinute))
                    }}>
                    <IonIcon icon={addCircle} size="large"/>
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonCardContent>
          </IonCard>
        </IonRow>
        <IonRow className="fullWidth responsive-row">
          <IonCard className="p-2 m-2 fullWidth">
          <IonCardHeader>
              <IonCardSubtitle mode="md" >Minutes</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <IonRow>
                <IonCol className="flex justify-center items-center">
                  <IonButton 
                    fill="clear"
                    onClick={() => {
                      const newMinute = minutes - 5
                      setMinutes(errorLength(newMinute))
                    }}>
                    <IonIcon icon={removeCircle} size="large"/>
                  </IonButton>
                </IonCol>
                <IonCol className="flex justify-center items-center">
                  <div style={{'backgroundColor': '#edeef0'}} className="p-2 rounded-8 fullWidth">
                    <h1 className="color_black flex justify-center items-center">{convertMinutes(minutes)}</h1>
                  </div>
                </IonCol>
                <IonCol className="flex justify-center items-center">
                  <IonButton 
                    fill="clear"
                    onClick={() => {
                      const newMinute = minutes + 5
                      setMinutes(errorLength(newMinute))
                    }}>
                    <IonIcon icon={addCircle} size="large"/>
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonCardContent>
          </IonCard>
        </IonRow>
      </IonRow>
      <IonRow className="flex items-center mt-8">
        <IonChip color="darkblue" className="circle_small flex justify-center items-center mx-2">3</IonChip>
        <h2 className="color_blue">{api.tr('Walktime_preview')}</h2>
      </IonRow>
      <IonRow className="p-8">
        <IonCard className="m-4 fullWidth">
          <IonCardHeader className="p-2">
            <IonCardTitle mode="md" >
            { dayjs(date as string).format('MMMM DD') }
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <IonItem>
              <IonLabel>{api.tr('StartLength_walk')}</IonLabel>
              <IonText>{ dayjs(date as string).format('HH:mm') }</IonText>
            </IonItem>
            <IonItem>
              <IonLabel>{api.tr('EndLength_walk')}</IonLabel>
              <IonText>{ dayjs(date as string).add(minutes, 'minutes').format('HH:mm') }</IonText>
            </IonItem>
            <IonText color="danger">{minutes === 0 ? 'Kontrollera längden på din promenad' : null}</IonText>
          </IonCardContent>
        </IonCard>
        </IonRow>
        <IonButton
          fill="solid"
          expand="block"
          onClick={() => {
            slideNext()
          }}>
          {api.tr('ContinueNext_page')}
        </IonButton>
        <IonButton
        className="m-2"
          fill="clear"
          expand="block"
          color="danger"
          onClick={() => {
            cancelCreate()
          }}>
          {api.tr('cancel')}
        </IonButton>
      <IonModal 
        mode="ios"
        keepContentsMounted={true} 
        color="teal" >
        <IonCard>
          <IonDatetime
            locale={api.lang}
            presentation="time"
            showDefaultButtons={true}
            minuteValues="0,05,10,15,20,25,30,35,40,45,50,55"
            multiple={false}
            value={dayjs(date as string).format('YYYY-MM-DDTHH:mmZ')} 
            color="teal"
            id="datetime" 
            onIonChange={(e) => {
              setDate(e.detail.value)
            }}/>
        </IonCard>
      </IonModal>
      <IonModal 
        mode="ios"
        keepContentsMounted={true} 
        color="teal" >
        <IonCard>
          <IonDatetime
            locale={api.lang}
            presentation="date"
            showDefaultButtons={true}
            minuteValues="0,05,10,15,20,25,30,35,40,45,50,55"
            multiple={false}
            value={dayjs(date as string).format('YYYY-MM-DDTHH:mmZ')} 
            color="teal"
            id="date" 
            onIonChange={(e) => {
              setDate(e.detail.value)
            }}/>
        </IonCard>
      </IonModal>
      <IonModal  
        className="modal_centered"
        isOpen={openCal} 
        onDidDismiss={() => setOpenCal(false)}>
          <IonHeader>
            <IonToolbar>
              <IonButtons>
                <IonButton onClick={() => setOpenCal(false)}>
                  <IonIcon icon={arrowBack}/>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
        <IonToolbar className="" color="darkblue">
          <IonRow className="flex justify-center">
            <h2>{dayjs(date as string).format('MMMM DD')}</h2>
          </IonRow>
          <IonRow>
            Tid
          </IonRow>
        </IonToolbar>
        <CreateCalendarPickerTimeline 
          openSync={openSync}
          closeSync={closeCalendarSync}
          setTimePicker={setTimePicker}
          day={start}
          end={endtime}/>
      </IonModal>
      <SafetyPadding/>
    </IonContent>
  )
}
export default CreateTime